import React from "react";
import Message from "./Message";
import "./Message.scss";

const Messages = ({ items }) => {
  return (
    <div className="message">
      {items.map((value, index) => {
        return <Message message={value} index={index} />;
      })}
    </div>
  );
};
export default Messages;
